var map = {
	"./symbol_0.png": 16193,
	"./symbol_1.png": 78712,
	"./symbol_2.png": 40819,
	"./symbol_3.png": 85610,
	"./symbol_4.png": 52485,
	"./symbol_5.png": 69596,
	"./symbol_6.png": 27703,
	"./symbol_7.png": 98478,
	"./symbol_8.png": 14041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36380;